import { NgModule, LOCALE_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatDividerModule, MatListModule, MatSlideToggleModule, MatCardModule, MatProgressSpinnerModule, MatIconModule } from '@angular/material';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateModule } from '@ngx-translate/core';
import { FuseSharedModule } from '@fuse/shared.module';

import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';
registerLocaleData(localeRu, 'ru-RU');

import { FuseQuickPanelComponent } from 'app/main/quick-panel/quick-panel.component';

@NgModule({
    declarations: [
        FuseQuickPanelComponent
    ],
    imports     : [
        RouterModule,
        TranslateModule,

        MatDividerModule,
        MatListModule,
        MatSlideToggleModule,
        MatCardModule,
        MatProgressSpinnerModule,
        MatIconModule,

        FuseSharedModule,
    ],
    exports: [
        FuseQuickPanelComponent
    ],
    providers: [
        {
            provide: LOCALE_ID,
            useFactory: (settingsService) => settingsService.getLang(),
            deps: [FuseTranslationLoaderService]
        }
    ]
})
export class FuseQuickPanelModule
{
}



// WEBPACK FOOTER //
// ./src/app/main/quick-panel/quick-panel.module.ts